/* eslint-disable import/no-unresolved */
import AuditLogsColumnConfig from 'views/Rules/common/AuditLogsColumnConfig';
import FRY9CAuditLog from '../components/FRY9CAduitLog';

const FRY9CAduitLogs = ({ data }) => {
    const fry9cColumns = AuditLogsColumnConfig;

    return (
        <FRY9CAuditLog
            data={data}
            columns={fry9cColumns}
        />
    );
};

export default FRY9CAduitLogs;
